import React from 'react';

// Components
import { Tooltip, TooltipPlacement } from '../../../../atoms/Tooltip';

import { Namespace } from '../../../../../translation/namespace';

import useCollapsibleOverlay from '../../../../../hooks/useCollapsibleOverlay';
import { CollapsibleModifier } from '../../../../organisms/CollapsibleOverlay/CollapsibleOverlay.modifier';
import { useSonTranslation } from '../../../../../translation/useSonTranslation';
import { CollapsibleContentSpan } from '../../../../organisms/CollapsibleOverlay/CollapsibleOverlay';
import { Modifier } from '../../../../../lib/bemUtils/Modifier';

type FormHelpProperties = {
  id: string;
  helpText: string;
  tooltipPlacement?: TooltipPlacement;
  modifier?: string;
  collapsibleModifier?: Modifier<CollapsibleModifier>;
};

/**
 * Renders a button in a Label with an Tooltip.
 * Is used by <a href='#formlabel'>FormLabel</a>.
 */
export default function FormHelp({
  id,
  helpText,
  tooltipPlacement = TooltipPlacement.RIGHT,
  modifier,
  collapsibleModifier,
}: FormHelpProperties) {
  const { t } = useSonTranslation(Namespace.FormHelp);
  const { toggleProps, collapsibleProps, collapsibleOpen } = useCollapsibleOverlay();

  return (
    <span className={`form-help${modifier ? ` ${modifier}` : ''}`} id={id}>
      <span className="form-help__text-container">
        <Tooltip attachTo={toggleProps.ref} placement={tooltipPlacement} hideOnClick>
          <button type="button" className="form-help__button" title={t('help')} aria-label={t('help')} {...toggleProps}>
            <span aria-hidden="true">?</span>
          </button>
        </Tooltip>
        <CollapsibleContentSpan {...collapsibleProps} modifier={collapsibleModifier || CollapsibleModifier.FORM_HELP}>
          {collapsibleOpen && <span className="form-help__text">{helpText}</span>}
        </CollapsibleContentSpan>
      </span>
    </span>
  );
}
